module.exports = __webpack_public_path__ + "img/ssvip.61fc747d.svg";